
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import Label             from '../Label';
import Input             from '../Input';
import RadioOption       from '../RadioOption';
import InputSection      from '../InputSection';
import InputGroup        from '../InputGroup';
import Button            from '../Button';
import InlineError       from '../InlineError';
import GlobalMessage     from '../GlobalMessage';
import PromotionCodeForm from '../PromotionCodeForm';
import AccordionSection  from '../AccordionSection';

import { reduxForm } from 'redux-form';

import paymentApi        from '../../services/payment';
import stripeApi         from '../../services/stripe';
import responseFormatter from '../../services/responseFormatter';
import costCalculator    from '../../services/costCalculator';
import trimmer           from '../../services/trimmer';
import {scrollToElementId} from '../../services/dom/elementScroller';

import * as paymentActions from '../../actions/payment';
import SelectBox from "../SelectBox";

class BookingPayment extends React.Component {

    constructor(props) {
        super(props);

        this._onChangeCountry = this._onChangeCountry.bind(this);
        this._selectResidingCountry = this._selectResidingCountry.bind(this);
        this._getCountries = this._getCountries.bind(this);
    }

    componentDidMount() {

        if(this.props.countries && this.props.countries.length === 0) {
            this._getCountries()
                .then(this._selectResidingCountry);
        }
    }

    componentDidUpdate() {

        this._refreshPaymentMethod();
    }

    _getCountries() {

        return this.props.getCountries();
    }

    _selectResidingCountry() {
        if (this.props.currentCountryId) {
            this.props.onChangeCountry(this.props.currentCountryId);
            this.props.fields.billing_address.country.onChange(this.props.currentCountryId);
        }
    }

    _onChangeCountry(e) {

        this.props.onChangeCountry(e.target.value);
        this.props.fields.billing_address.country.onChange(e.target.value);
    }

    _refreshPaymentMethod() {

        if (!this.props.fields.payment_method.value && this._isAmountToPay()) {

            this.props.fields.payment_method.onChange('invoice');
        }
    }

    _getInvoiceSection() {

        if (this.props.fields.payment_method.value === 'invoice') {

            const { fields: { invoice_email, po_number } } = this.props;

            return (
                <InputSection>

                    <InputGroup>
                        <Label>Purchase Order Number</Label>
                        <Input { ...po_number } errors={ po_number.error } placeholder="Leave blank if no order number" />
                        <InlineError errors={ po_number.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Email for Invoice</Label>
                        <Input { ...invoice_email } type="email" errors={ invoice_email.error } />
                        <InlineError errors={ invoice_email.error } />
                    </InputGroup>

                </InputSection>
            );
        }
    }

    _getBillingAddressComponent() {

        const { fields: { billing_address } } = this.props;

        return (
            <AccordionSection>
                <InputSection>
                    <strong className={style['section-title']}>Billing Address</strong>

                    <div className={`${style['section-content']} ${style['section-content--spaced']}`}>
                        <InputGroup>

                            <Label isRequired="true">Address Line 1</Label>
                            <Input { ...billing_address.address_1 } errors={ billing_address.address_1.error } />
                            <InlineError errors={ billing_address.address_1.error } />

                        </InputGroup>

                        <InputGroup>

                            <Label>Address Line 2</Label>
                            <Input { ...billing_address.address_2 } errors={ billing_address.address_2.error } />
                            <InlineError errors={ billing_address.address_2.error } />

                        </InputGroup>

                        <InputGroup>

                            <Label isRequired="true">Town / City</Label>
                            <Input { ...billing_address.town_city } errors={ billing_address.town_city.error } />
                            <InlineError errors={ billing_address.town_city.error } />

                        </InputGroup>

                        <InputGroup>

                            <Label isRequired="true">Post Code</Label>
                            <Input { ...billing_address.post_code } errors={ billing_address.post_code.error } />
                            <InlineError errors={ billing_address.post_code.error } />

                        </InputGroup>

                        <InputGroup>

                            <Label isRequired="true">Country</Label>
                            <SelectBox { ...billing_address.country } errors={ billing_address.country.error } onChange={(e) => this._onChangeCountry(e)}>
                                <option value="">-- Please select --</option>
                                { this.props.countries.map( (country) => {
                                    return (
                                        <option selected={this.props.country && this.props.country.id == country.id} value={ country.id }>{ country.name }</option>
                                    )
                                })}
                            </SelectBox>
                            <InlineError errors={ billing_address.country.error } />

                        </InputGroup>

                    </div>
                </InputSection>
            </AccordionSection>
        );
    }

    _getCardDetailsComponent() {

        const { fields: { card_details }, error } = this.props;

        return (
            <AccordionSection>

                <strong className={style['section-title']}>Card Details</strong>

                <div className={`${style['section-content']} ${style['section-content--spaced']}`}>
                    <GlobalMessage className={ style['global-card-error'] } type="error" show={ error }>
                        { error }
                    </GlobalMessage>

                    <InputGroup>

                        <Label isRequired="true">Card Number</Label>
                        <Input { ...card_details.card_number } errors={ card_details.card_number.error } />
                        <InlineError errors={ card_details.card_number.error } />

                    </InputGroup>

                    <InputGroup>

                        <Label isRequired="true">Expiry Date</Label>

                        <div styleName="expiry-input-container">

                            <Input { ...card_details.expiry_month }
                                errors={ card_details.expiry_month.error }
                                className={ style['expiry-input'] }
                                placeholder="MM" />

                            <span>/</span>

                            <Input { ...card_details.expiry_year }
                                errors={ card_details.expiry_year.error }
                                className={ style['expiry-input'] }
                                placeholder="YY" />
                        </div>

                        <InlineError errors={ card_details.expiry_month.error } />
                        <InlineError errors={ card_details.expiry_year.error } />

                    </InputGroup>

                    <InputGroup>

                        <Label>Security Code</Label>
                        <Input { ...card_details.security_code }
                            errors={ card_details.security_code.error }
                            className={ style['security-input'] } />

                        <InlineError errors={ card_details.security_code.error } />

                    </InputGroup>
                </div>

            </AccordionSection>
        );
    }

    _getBillingAddressForm(paymentMethod) {

        if (paymentMethod === 'card' || paymentMethod === 'invoice') {

            return this._getBillingAddressComponent();
        }
    }

    _getCardDetailsForm(paymentMethod) {

        if (paymentMethod === 'card') {

            return this._getCardDetailsComponent();
        }
    }

    _submitBookingForm(formValues, dispatch) {

        return new Promise((resolve, reject) => {

            function stripeValidationSuccess(stripeResponse) {

                const paymentDetails = {
                    ...formValues,
                    stripe_token: stripeResponse.id
                };

                dispatch(paymentActions.proceedToConfirmation(paymentDetails));
                scrollToElementId('confirmation')
            }

            function paymentValidationSuccess() {

                dispatch(paymentActions.proceedToConfirmation(formValues));
                scrollToElementId('confirmation')
            }

            function validateFailed(response) {

                reject(responseFormatter.apiErrorsToFormErrors(response.data.errors, response.data.message));
                scrollToElementId('payment')
            }

            function getChargeToken() {

                const chargeDetails = {
                    card_details: formValues.card_details,
                    billing_address: formValues.billing_address
                };

                return stripeApi.getChargeToken(chargeDetails)
                    .then(stripeValidationSuccess, validateFailed);
            }

            formValues = trimmer.trim(formValues);

            if (!this._isAmountToPay()) {

                formValues.payment_method = undefined;
            }

            if (formValues.payment_method === 'card') {

                const paymentDetails = {
                    payment_method: formValues.payment_method,
                    billing_address: formValues.billing_address
                };

                return paymentApi.validatePayment(paymentDetails)
                    .then(getChargeToken, validateFailed);

            } else if (formValues.payment_method === 'invoice') {

                const paymentDetails = {
                    po_number: formValues.po_number,
                    payment_method: formValues.payment_method,
                    invoice_email: formValues.invoice_email,
                    billing_address: formValues.billing_address
                };

                return paymentApi.validatePayment(paymentDetails)
                    .then(paymentValidationSuccess, validateFailed);

            } else {

                const paymentDetails = {
                    payment_method: formValues.payment_method,
                    promotion_codes: formValues.promotion_codes
                };

                dispatch(paymentActions.proceedToConfirmation(paymentDetails));
            }
        });
    }

    _removePromoCode(promoCode) {

        const index = this.props.fields.promotion_codes.findIndex((promo) => {

            return promo.code.value === promoCode.code;
        });

        this.props.fields.promotion_codes.removeField(index);

        this.props.removePromoCode(promoCode);
    }

    _promoCodeApplied(promoCode) {

        if (!this._isPromoCodeApplied(promoCode)) {

            this.props.fields.promotion_codes.addField(promoCode);

            this.props.promotionCodeAdded(promoCode);
        }
    }

    _isPromoCodeApplied(promoCodeToCheck) {

        const matchingCodes = this.props.fields.promotion_codes.filter((promo) => {

            return promo.code.value === promoCodeToCheck.code;
        });

        return matchingCodes.length > 0;
    }

    _getCardRadioButton(payment_method) {

        // Emergency suppression of card payment for conference
        const REGULATION_ENFORCEMENT_CONFERENCE_COURSE_ID = 25;

        if (this.props.event && this.props.event.course.id === REGULATION_ENFORCEMENT_CONFERENCE_COURSE_ID)
            return null;
        // End emergency suppression

        return (
            <RadioOption
                { ...payment_method }
                className={style['payment-method-checkbox']}
                checked={ payment_method.value === 'card' }
                value="card"
                labelText="Credit/Debit Card"
            />
        );
    }

    _getPaymentOptions(payment_method) {

        return (
            <InputSection>

                <InputGroup>

                    <RadioOption { ...payment_method }
                                 className={style['payment-method-checkbox']}
                                 checked={ payment_method.value === 'invoice' }
                                 value="invoice"
                                 labelText="Invoice" />


                    { this._getCardRadioButton(payment_method) }

                </InputGroup>

            </InputSection>
        );
    }

    _getDelegatePrice() {
        if (this.props.event && this.props.event.overridden_price) {
            return this.props.event.overridden_price;
        } else if (this.props.eLearningCourse && this.props.eLearningCourse.overridden_price) {
            return this.props.eLearningCourse.overridden_price;
        }

        if (this.props.bookingValues.sector === 'public') {
            if (this.props.event) return this.props.event.public_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.public_price;
        } else if (this.props.bookingValues.sector === 'private') {
            if (this.props.event) return this.props.event.private_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.private_price;
        }
    }

    _getCostBreakdown() {

        const options = {
            eLearningCourse: this.props.eLearningCourse,
            delegates: this.props.bookingValues.attendees,
            full_delegate_price: this._getDelegatePrice(),
            promotion_codes: this.props.promotionCodes
        };

        return costCalculator.calculate(options);
    }

    _isAmountToPay() {

        const totalAmount = parseFloat(this._getCostBreakdown().total);

        return totalAmount > 0;
    }

    _getPaymentSections(payment_method) {

        if (this._isAmountToPay()) {

            return (
                <div>
                    <AccordionSection>
                        <strong className={style['section-title']}>Method</strong>

                        <div className={`${style['section-content']} ${style['section-content--spaced']}`}>
                            { this._getPaymentOptions(payment_method) }

                            { this._getInvoiceSection() }
                        </div>
                    </AccordionSection>

                    { this._getBillingAddressForm(payment_method.value) }

                    { this._getCardDetailsForm(payment_method.value) }
                </div>
            );
        }
    }

    render() {

        const { fields: { payment_method }, submitting, handleSubmit } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._submitBookingForm.bind(this)) }>

                { this._getPaymentSections(payment_method) }

                {
                    this.props.promotionCodes.map((promo, index) => {

                        return (
                            <GlobalMessage styleName="promo--message" key={ index } show={ true } type="success">
                                <span>Promotion code</span>&nbsp;
                                <span styleName="promo-code-review">{ promo.code }</span>&nbsp;
                                <span>applied</span>
                                <span onClick={ this._removePromoCode.bind(this, promo) }
                                      styleName="undo-promo-link">Undo</span>
                            </GlobalMessage>
                        );
                    })
                }

                <AccordionSection>
                    <strong className={style['section-title']}>Promotion</strong>
                    <div className={`${style['section-content']} ${style['section-content--spaced']}`}>
                        <PromotionCodeForm
                            eventId={ this.props.event ? this.props.event.id : null}
                            courseId={ this.props.eLearningCourse ? this.props.eLearningCourse.id : null}
                            applied={ this._promoCodeApplied.bind(this) }
                        />
                    </div>

                    <div className={style['section-content']}>
                        <Button onClick={ this.props.backToDelegates }
                                className={style['previous-button']}
                                type="button">

                            <span>Back</span>

                        </Button>

                        <Button className={style['proceed-button']}
                                disabled={ submitting }
                                type="submit">

                            <span>Next</span>

                        </Button>
                    </div>
                </AccordionSection>

            </form>
        );
    }
}

function mapStateToProps(state) {

    return {
        ...state.payment,
        initialValues: {
            ...state.payment.bookingValues
        }
    };
}

function mapDispatchToProps(dispatch) {

    return {
        getCountries() {

            return dispatch(paymentActions.getCountryList());
        },
        removePromoCode(promoCode) {

            dispatch(paymentActions.removePromoCode(promoCode));
        },
        promotionCodeAdded(promoCode) {

            dispatch(paymentActions.promotionCodeAdded(promoCode));
        },
        backToDelegates() {
            
            dispatch(paymentActions.backToDelegates());
            scrollToElementId('delegates')
        },
        onChangeCountry(id) {

            dispatch(paymentActions.getCountry(id));
        }
    };
}

const formParams = {
    form: 'booking-payment',
    fields: [
        'po_number',
        'payment_method',
        'invoice_email',
        'billing_address.address_1',
        'billing_address.address_2',
        'billing_address.town_city',
        'billing_address.post_code',
        'billing_address.country',
        'card_details.card_number',
        'card_details.expiry_month',
        'card_details.expiry_year',
        'card_details.security_code',
        'promotion_codes[].id',
        'promotion_codes[].code',
        'promotion_codes[].type'
    ]
};

export default reduxForm(formParams, mapStateToProps, mapDispatchToProps)(CSSModules(BookingPayment, style));


// WEBPACK FOOTER //
// ./components/BookingPayment/index.js